<template>
  <div class="uni-login">
    <div class="login-container">
      <!--<img class="logo-title" src="https://tcr-4w06clvb-1303139375.cos.ap-beijing.myqcloud.com/gamma/images/2021-10/1635209489184_%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20211026085111.png" alt />-->
      <img class="logo-title" src="https://tcr-4w06clvb-1303139375.cos.ap-beijing.myqcloud.com/gamma/images/2021-10/1635209489184_%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20211026085111.png" alt />

      <!-- 选择入口 继续教育/自考考试 -->
      <div class="login-content choice-port" v-if="isShowPort == 1">
        <div class="port-box port-box1">
          <div class="port-item">
            <div class="item-title">成人高等教育入口 </div>
            <div class="item-img">
              <img class="img" src="../../assets/images/choice_port1.png" alt="">
            </div>
            <div class="item-btn">
              <el-button type="primary" class="btn" size="small" @click="choicePortClick('adult')">点击进入>></el-button>
            </div>
          </div>
          <div class="port-item">
            <div class="item-title">自学考试入口 </div>
            <div class="item-img">
              <img class="img" src="../../assets/images/choice_port2.png" alt="">
            </div>
            <div class="item-btn">
              <el-button type="primary" class="btn" size="small" @click="choicePortClick('own')">点击进入>></el-button>
            </div>
          </div>
        </div>
        <div class="port-box port-box2">
          <div class="port-item">
            <div class="item-title">学位申报入口 </div>
            <div class="item-img">
              <img class="img" src="../../assets/images/choice_port2.png" alt="">
            </div>
            <div class="item-btn">
              <el-button type="primary" class="btn" size="small" @click="choicePortClick('academicDegree')">点击进入>></el-button>
            </div>
          </div>
          <div class="port-item">
            <div class="item-title">毕业证明书 </div>
            <div class="item-img">
              <img class="img" src="../../assets/images/choice_port2.png" alt="">
            </div>
            <div class="item-btn">
              <el-button type="primary" class="btn" size="small" @click="choicePortClick('graduationProve')">点击进入>></el-button>
            </div>
          </div>
          <div class="port-item">
            <div class="item-title">实践考核及毕业设计（论文）报名入口</div>
            <div class="item-img">
              <img class="img" src="../../assets/images/choice_port2.png" alt="">
            </div>
            <div class="item-btn">
              <el-button type="primary" class="btn" size="small" @click="choicePortClick('practicalAssessment')">点击进入>></el-button>
            </div>
          </div>
        </div>
      </div>

      <!--login  -->
      <div class="login-content" v-else-if="isShowPort == 2">
        <div class="login-content_icon" @click="backClick"><i class="el-icon-arrow-left"></i></div>
        <div class="login-content_title">
          {{portValue | portValueFilter}}
        </div>
        <div class="wx">
          <!--<span>
            <i
              class="iconfont"
              :class="isActive ? 'icondiannao' : 'iconweixin1'"
            ></i>
            {{ isActive ? "电脑登陆" : "微信登陆" }}
          </span>
          <span
            class="uni-login-type"
            :class="{ active: isActive }"
            @click="changeLogin"
          ></span>-->
        </div>
          <!-- 电脑登陆 -->
          <el-tabs v-model="activeName" class="uni-tabs" v-show="!isActive">
            <!-- 密码登陆1   -->
            <el-tab-pane label="密码登陆" name="first">
              <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
                <!-- 身份证 -->
                <div class="uni-input-group">
                  <span
                    class="uni-label"
                    :class="{
                      active:
                        isLabelActive == 'account' || ruleForm.account != '',
                    }"
                    @click="inputGroupClick"
                    >手机号/身份证</span
                  >

                  <el-form-item prop="account" class="uni-input">
                    <el-input
                      clearable
                      v-model.trim="ruleForm.account"
                      name="account"
                      type="text"
                      autocomplete="new-password"
                      @focus="changeLabelFocus"
                      @blur="changeLabelBlur"
                    ></el-input>
                  </el-form-item>
                </div>

                <!-- 密码 -->
                <div class="uni-input-group">
                  <span
                    class="uni-label"
                    :class="{
                      active:
                        isLabelActive == 'password' || ruleForm.password != '',
                    }"
                    @click="inputGroupClick"
                    >密码</span
                  >

                  <el-form-item prop="password" class="uni-input">
                    <el-input
                      autocomplete="new-password"
                      v-model="ruleForm.password"
                      name="password"
                      :type="isOpen"
                      @focus="changeLabelFocus"
                      @blur="changeLabelBlur"
                      @keyup.enter.native="refer('密码')"
                    ></el-input>
                  </el-form-item>

                  <i
                    class="iconfont iconclose_eyes_"
                    @click="showPassword"
                    v-show="isOpen == 'password'"
                  ></i>
                  <i
                    class="iconfont iconyanjing"
                    @click="showPassword"
                    v-show="isOpen == 'text'"
                  ></i>
                </div>
                <el-link
                  type="info"
                  style="float: right; color: #5879ff"
                  @click="handleForgetPwd"
                  >忘记密码
                </el-link>
                <el-button type="primary" class="refer-btn" @click="refer('密码')"
                  >登陆
                </el-button>
              </el-form>
            </el-tab-pane>

            <!-- 验证码登陆 -->
            <el-tab-pane label="验证码登陆" name="second">
              <el-form :model="codeForm" :rules="codeRules" ref="codeForm">
                <!-- 手机号 -->
                <div class="uni-input-group">
                  <span
                    class="uni-label"
                    :class="{
                      active: isLabelActive == 'mobile' || codeForm.mobile != '',
                    }"
                    @click="inputGroupClick"
                    >手机号</span
                  >

                  <el-form-item prop="mobile" class="uni-input">
                    <el-input
                      clearable
                      autocomplete="off"
                      v-model.trim="codeForm.mobile"
                      name="mobile"
                      @focus="changeLabelFocus"
                      @blur="changeLabelBlur"
                    ></el-input>
                  </el-form-item>
                </div>

                <!-- 验证码 -->
                <div class="uni-input-group">
                  <span
                    class="uni-label"
                    :class="{
                      active: isLabelActive == 'code' || codeForm.code != '',
                    }"
                    @click="inputGroupClick"
                    >验证码</span
                  >

                  <el-form-item prop="code" class="uni-input">
                    <el-input
                      autocomplete="off"
                      v-model="codeForm.code"
                      name="code"
                      @focus="changeLabelFocus"
                      @blur="changeLabelBlur"
                      @keyup.enter.native="refer('验证码')"
                    ></el-input>
                  </el-form-item>

                  <el-button
                    round
                    class="uni-code"
                    @click="getCode(60)"
                    :disabled="isTimer"
                    >{{ !isTimer ? "获取验证码" : `(${timerCount}s) 重发` }}
                  </el-button>
                </div>

                <el-button
                  type="primary"
                  class="refer-btn"
                  @click="refer('验证码')"
                  >登陆
                </el-button>
              </el-form>
            </el-tab-pane>
          </el-tabs>
          <!-- 微信登陆 -->
          <!--<div class="uni-wx-content" v-show="isActive">
            <div id="login_container">
              <img :src="qrCode" width="350" />
            </div>
          </div>-->
          <!-- <div class="uni-tips" v-if="!isActive">
            登陆不成功?
            <span class="link" @click="concatFunc">联系管理员</span>
          </div> -->
      </div>

      <!-- 选择班级 -->
      <div class="login-content" v-else-if="isShowPort == 3">
        <div class="login-content_icon" @click="()=>{this.isShowPort = 2}"><i class="el-icon-arrow-left"></i></div>
        <div class="login-content_select">
          <el-select v-model="classCurrent" placeholder="请选择班级" style="width: 100%">
            <el-option
              v-for="item in classList"
              :key="item.class_id"
              :label="item.className"
              :value="item.class_id">
            </el-option>
          </el-select>
          <el-button
            type="primary"
            class="refer-btn"
            @click="classConfirm"
          >确认班级</el-button>
        </div>

      </div>

      <!-- 学位申报登录 -->
      <!-- <div class="login-content" v-else-if="isShowPort == 4">
        <div class="login-content_icon" @click="()=>{this.isShowPort = 1}"><i class="el-icon-arrow-left"></i></div>
        <div class="login-content_title">
          {{portValue | portValueFilter}}
        </div>
        <div class="wx">
        </div>
        <el-tabs v-model="activeName" class="uni-tabs" v-show="!isActive">
          <el-tab-pane label="密码登陆" name="first">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
              <div class="uni-input-group">
                <span
                  class="uni-label"
                  :class="{
                    active:
                      isLabelActive == 'account' || ruleForm.account != '',
                  }"
                  @click="inputGroupClick"
                  >手机号</span
                >

                <el-form-item prop="account" class="uni-input">
                  <el-input
                    clearable
                    v-model.trim="ruleForm.account"
                    name="account"
                    type="text"
                    autocomplete="new-password"
                    @focus="changeLabelFocus"
                    @blur="changeLabelBlur"
                  ></el-input>
                </el-form-item>
              </div>
              <div class="uni-input-group">
                <span
                  class="uni-label"
                  :class="{
                    active:
                      isLabelActive == 'password' || ruleForm.password != '',
                  }"
                  @click="inputGroupClick"
                  >密码</span
                >

                <el-form-item prop="password" class="uni-input">
                  <el-input
                    autocomplete="new-password"
                    v-model="ruleForm.password"
                    name="password"
                    :type="isOpen"
                    @focus="changeLabelFocus"
                    @blur="changeLabelBlur"
                    @keyup.enter.native="degreeApplicationSignIn"
                  ></el-input>
                </el-form-item>

                <i
                  class="iconfont iconclose_eyes_"
                  @click="showPassword"
                  v-show="isOpen == 'password'"
                ></i>
                <i
                  class="iconfont iconyanjing"
                  @click="showPassword"
                  v-show="isOpen == 'text'"
                ></i>
              </div>
              <el-link
                type="info"
                style="float: right; color: #5879ff"
                @click="handleForgetPwd"
                >忘记密码
              </el-link>
              <el-button type="primary" class="refer-btn" @click="degreeApplicationSignIn"
                >登陆
              </el-button>
            </el-form>
          </el-tab-pane>
        </el-tabs>
        <div class="uni-tips" v-if="!isActive">
          登陆不成功?
          <span class="link" @click="concatFunc">联系管理员</span>
        </div>

      </div> -->

      <!-- 实践考核入口 -->
      <div class="login-content" v-else-if="isShowPort == 5">
        <div class="login-content_icon" @click="backClick"><i class="el-icon-arrow-left"></i></div>
        <div class="login-content_title">
          {{portValue | portValueFilter}}
        </div>
        <div class="wx"></div>
        <div class="uni-tabs">
            <el-form :model="practicalAssessmentRuleForm" :rules="practicalAssessmentRules" ref="practicalAssessmentRuleForm">
                <!-- 身份证 -->
                <div class="uni-input-group">
                  <span
                    class="uni-label"
                    :class="{
                      active:
                        isLabelActive == 'identity' || practicalAssessmentRuleForm.identity != '',
                    }"
                    @click="inputGroupClick"
                    >身份证</span
                  >

                  <el-form-item prop="identity" class="uni-input">
                    <el-input
                      clearable
                      v-model.trim="practicalAssessmentRuleForm.identity"
                      name="identity"
                      type="text"
                      autocomplete="new-password"
                      @focus="changeLabelFocus"
                      @blur="changeLabelBlur"
                    ></el-input>
                  </el-form-item>
                </div>
                <!-- 准考证号 -->
                <div class="uni-input-group">
                  <span
                    class="uni-label"
                    :class="{
                      active:
                        isLabelActive == 'exam_number' || practicalAssessmentRuleForm.exam_number != '',
                    }"
                    @click="inputGroupClick"
                    >准考证号</span
                  >

                  <el-form-item prop="exam_number" class="uni-input">
                    <el-input
                      clearable
                      v-model.trim="practicalAssessmentRuleForm.exam_number"
                      name="exam_number"
                      type="text"
                      autocomplete="new-password"
                      @focus="changeLabelFocus"
                      @blur="changeLabelBlur"
                    ></el-input>
                  </el-form-item>
                </div>

                <!-- 学生姓名 -->
                <div class="uni-input-group">
                  <span
                    class="uni-label"
                    :class="{
                      active:
                        isLabelActive == 'student_title' || practicalAssessmentRuleForm.student_title != '',
                    }"
                    @click="inputGroupClick"
                    >学生姓名</span
                  >

                  <el-form-item prop="student_title" class="uni-input">
                    <el-input
                      clearable
                      v-model.trim="practicalAssessmentRuleForm.student_title"
                      name="student_title"
                      type="text"
                      autocomplete="new-password"
                      @focus="changeLabelFocus"
                      @blur="changeLabelBlur"
                    ></el-input>
                  </el-form-item>
                </div>

                <!-- 手机号 -->
                <div class="uni-input-group">
                  <span
                    class="uni-label"
                    :class="{
                      active: isLabelActive == 'phone' || practicalAssessmentRuleForm.phone != '',
                    }"
                    @click="inputGroupClick"
                    >手机号</span
                  >

                  <el-form-item prop="phone" class="uni-input">
                    <el-input
                      clearable
                      autocomplete="off"
                      v-model.trim="practicalAssessmentRuleForm.phone"
                      name="phone"
                      @focus="changeLabelFocus"
                      @blur="changeLabelBlur"
                    ></el-input>
                  </el-form-item>
                </div>

                <!-- 验证码 -->
                <!-- <div class="uni-input-group">
                  <span
                    class="uni-label"
                    :class="{
                      active: isLabelActive == 'sms_code' || practicalAssessmentRuleForm.sms_code != '',
                    }"
                    @click="inputGroupClick"
                    >验证码</span
                  >

                  <el-form-item prop="sms_code" class="uni-input">
                    <el-input
                      autocomplete="off"
                      v-model="practicalAssessmentRuleForm.sms_code"
                      name="sms_code"
                      @focus="changeLabelFocus"
                      @blur="changeLabelBlur"
                    ></el-input>
                  </el-form-item>

                  <el-button
                    round
                    class="uni-code"
                    @click="getCodePracticalAssessment(60)"
                    :disabled="isTimer"
                    >{{ !isTimer ? "获取验证码" : `(${timerCount}s) 重发` }}
                  </el-button>
                </div> -->

                <el-button type="primary" class="refer-btn" @click="refer('practicalAssessment')"
                  >登陆
                </el-button>
              </el-form>
        </div>
      </div>

      <img class="unit-bootom-img" src="@/assets/images/login_bg2.png" alt />
    </div>
    <p class="ori-footerUrl" style="">
      <i></i><span @click="isUrl(3)">渝公网安备 50010602502220 号</span>，
      技术支持：<span @click="isUrl(1)">重庆卓培教育科技有限公司</span>，<span
        @click="isUrl(2)"
        >渝ICP备18010001号-6</span
      >
    </p>
  </div>
</template>

<script>
import { mobileReg } from "@/utils/regExp";
import { login, v1MobileLogin, getCode, codeServe, pracLogin } from "@/api/login";
import { setStore, setLocalStore, getLocalStore } from "@/utils/localStorage";
import {selectMajor} from "@/api/basic";
import {mapMutations} from "vuex";

export default {
  name: "Login",
  filters: {
    // 端口列表
    portValueFilter(v){
      let obj = {
        'adult': '继续教育登录',
        'own': '自学考试登录',
        'practicalAssessment': '实践考核及毕业设计入口',
      };
      return obj[v];
    },
  },
  data() {
    return {
      isShowPort: 1,  //选择入口 1 继续教育/自考考试 2登录 3选择班级
      portValue: "",  //选择入口的值

      activeName: "first",
      isActive: false,
      isLabelActive: "",
      timerCount: 60,
      timer: null,
      isTimer: false,
      isOpen: "password",
      qrCode: "",
      ticket: "",
      ruleForm: {
        account: "",
        password: "",
      },
      codeForm: {
        mobile: "",
        code: "",
      },
      rules: {
        account: [
          {
            required: true,
            message: "请输入手机号/身份证",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
        ],
      },
      codeRules: {
        mobile: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
          {
            pattern: mobileReg,
            message: "手机号格式不正确",
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "blur",
          },
        ],
      },
      codeData: "",
      codeText: "",
      ipData: "",

      classCurrent:'',
      classList:[],

      // 实践考核数据
      practicalAssessmentRuleForm: {
        identity: '',  //身份证号
        exam_number: '',  //准考证号
        student_title: '',  //学生姓名
        phone: '',  //手机号
        sms_code: '',  //验证码
      },
      practicalAssessmentRules: {
        identity: [{required: true, message: "请输入身份证号", trigger: "blur"}],
        exam_number: [{required: true, message: "请输入准考证号", trigger: "blur"}],
        student_title: [{required: true, message: "请输入学生姓名", trigger: "blur"}],
        phone: [{required: true, message: "请输入手机号", trigger: "blur"}],
        sms_code: [{required: true, message: "请输入验证码", trigger: "blur"}],
      },
    };
  },
  created() {
    document.body.className = "";
    document.title = "重庆交通大学";
    this.clearCache();
    const entranceType = localStorage.getItem('_ENTRANCETYPE')
    // if(entranceType){
    //   this.isShowPort = false
    // }
    // else{
    //   this.isShowPort = true
    // }
  },
  mounted() {

    //this.getQrcode();
    const searchName = window.location.search;
    if (searchName !== "") {
      const token = getLocalStore("token");
      const [, urlData] = searchName.split("?");
      const [urlDataArr, urlDataArr1] = urlData.split("&");
      const [, urlDataCode] = urlDataArr.split("=");
      const [, urlDataCode1] = urlDataArr1.split("=");
      if (urlDataCode1 !== "None" && token) {
        this.codeBind(urlDataCode, urlDataCode1, token);
        return;
      }
      if (urlDataCode1 === "None") {
        this.getUserIP((ip) => {
          this.ipData = ip || "ffzs";
          setStore("ipData", this.ipData);
        });
      }
    } else {
      this.getUserIP((ip) => {
        this.ipData = ip || "ffzs";
        setStore("ipData", this.ipData);
      });
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  methods: {
    ...mapMutations("common", ["gerStudentMajorMutation"]),

    // 返回
    backClick(){
      this.isShowPort = 1;
      this.ruleForm = {
        account: "",
        password: "",
      };
    },

    // 学位申报登录
    // degreeApplicationSignIn(){
    //   let userInfo = {
    //     user_type: 'student',
    //   };
    //   setStore("userInfo", userInfo); //用户信息
    //   this.$router.push({
    //     name: "degreeApplication",
    //   });
    // },

    // 选择入口
    choicePortClick(v){
      this.portValue = v;
      // window.localStorage.setItem('_ENTRANCETYPE',v)
      this.$store.dispatch('permission/SETENTRANCETYPE', v);
      if(v === 'adult' || v === 'own'){
        this.isShowPort = 2;
      }
      else if(v === 'academicDegree'){
        // this.isShowPort = 4;
          this.$router.push({
            name: "degreeApplication",
          });
      }
      else if(v === 'graduationProve'){
        this.$router.push({
          name: "graduationProve",
        });
      }else if(v === 'practicalAssessment'){
        this.isShowPort = 5;
      }
    },
    async isLogin() {
      if (this.ticket) {
        const data = await codeServe.isLogin({ ticket: this.ticket });
        //console.log(data)
        if (data.code === 200) {
          if (data.result) {
            setStore("token", data.result.token); //token
            setLocalStore("token", data.result.token); //token
            setStore("userInfo", data.result); //用户信息
            this.$store.dispatch('permission/userInfoActions', JSON.stringify(data.result));
            clearInterval(this.timer);
            // this.$message.success("登陆成功");
            if (data.result.user_type === "teacher") {
              // 根据老师的类型跳转页面
              this.$router.replace({
                path: this.IdentityFilter(

                  data.result.teacher_type_array[0]
                ),
              });
            } else if (data.result.user_type === "student") {
              // await this.selectZy(data.result.classList[0].profession_id);
              this.classList = data.result.classList
              this.isShowPort = 3;

              // await this.selectZy(data.result.classList[0].class_id);
              // if (data.result.first_login_verify === 0) {
              //   // this.$router.push("/upDataIDQr");
              //   this.$router.push("/verify");
              //   return;
              // }
              // this.$router.replace({
              //   path: "/Template",
              // });
            }
          }
        }
      }
    },
    getUserIP(onNewIP) {
      //  onNewIp - your listener function for new IPs
      let MyPeerConnection =
        window.RTCPeerConnection ||
        window.mozRTCPeerConnection ||
        window.webkitRTCPeerConnection;
      let pc = new MyPeerConnection({
        iceServers: [],
      });
      let noop = () => {};
      let localIPs = {};
      let ipRegex =
        /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g;
      let iterateIP = (ip) => {
        if (!localIPs[ip]) {
          onNewIP(ip);
        }
        localIPs[ip] = true;
      };
      pc.createDataChannel("");
      pc.createOffer()
        .then((sdp) => {
          sdp.sdp.split("\n").forEach(function (line) {
            if (line.indexOf("candidate") < 0) {
              return;
            }
            line.match(ipRegex).forEach(iterateIP);
          });
          pc.setLocalDescription(sdp, noop, noop);
        })
        .catch((reason) => {
          console.log(reason);
        });
      pc.onicecandidate = (ice) => {
        if (
          !ice ||
          !ice.candidate ||
          !ice.candidate.candidate ||
          !ice.candidate.candidate.match(ipRegex)
        ) {
          return;
        }
        ice.candidate.candidate.match(ipRegex).forEach(iterateIP);
      };
    },
    clearCache() {
      this.$store.commit("common/clearStore");
      window.sessionStorage.clear();
    },
    isUrl(type) {
      let urlText = "";
      if (type === 1) urlText = "https://www.zpjykj.com/";
      if (type === 2) urlText = "https://beian.miit.gov.cn/#/Integrated/index";
      if (type === 3)
        urlText =
          "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=50010602502220";
      window.open(urlText);
    },
    async codeBind(code, url, token) {
      const codeDataLogin = await codeServe.login(
        {
          code: code,
        },
        {
          token: token,
        }
      );
      if (codeDataLogin.data.message === "绑定成功") {
        this.$message({
          message: "绑定成功",
          type: "success",
        });
      }
    },
    //  忘记密码跳转
    handleForgetPwd() {
      this.$router.push("/forgetPwd");
    },
    // 获取微信二维码图片
    async getQrcode() {
      const data = await codeServe.qrcode({ scene_str: "courier_login" });
      if (data.code === 200) {
        this.qrCode = data.result.qrcode;
        this.ticket = data.result.ticket;
      }
    },
    // 改变登陆方式
    changeLogin() {
      this.isActive = !this.isActive;
      if (this.isActive) {
        this.timer = setInterval(this.isLogin, 3000);
      } else {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    // label动画
    inputGroupClick(event) {
      const target = event.currentTarget;
      target.nextElementSibling.firstElementChild.firstElementChild.firstElementChild.focus();
    },
    changeLabelFocus(event) {
      const { name } = event.currentTarget;
      this.isLabelActive = name;
    },
    changeLabelBlur() {
      this.isLabelActive = "";
    },
    // 验证码 实践考核
    getCodePracticalAssessment(timeCount) {
      this.$refs.practicalAssessmentRuleForm.validateField("phone", (errorMessage) => {
        if (errorMessage === "") {
          this.getVerificationCodePracticalAssessment();
          if (!this.timer) {
            this.timerCount = timeCount;
            this.isTimer = true;
            this.timer = setInterval(() => {
              if (this.timerCount > 0 && this.timerCount <= timeCount) {
                this.timerCount -= 1;
              } else {
                this.isTimer = false;
                clearInterval(this.timer); // 清除定时器
                this.timer = null;
              }
            }, 1000);
          }
        }
      });
    },
    //验证码请求
    async getVerificationCodePracticalAssessment() {
      const params = {
        mobile: this.practicalAssessmentRuleForm.phone,
      };
      getCode(params).then((res) => {
        if (res.code === 200) {
          this.$message({ message: "发送成功", type: "success" });
        } else {
          this.$message.error("新增失败,请重试!");
        }
      });
    },
    // 验证码
    getCode(timeCount) {
      this.$refs.codeForm.validateField("mobile", (errorMessage) => {
        if (errorMessage === "") {
          this.getVerificationCode();
          if (!this.timer) {
            this.timerCount = timeCount;
            this.isTimer = true;
            this.timer = setInterval(() => {
              if (this.timerCount > 0 && this.timerCount <= timeCount) {
                this.timerCount -= 1;
              } else {
                this.isTimer = false;
                clearInterval(this.timer); // 清除定时器
                this.timer = null;
              }
            }, 1000);
          }
        }
      });
    },
    //验证码请求
    async getVerificationCode() {
      const params = {
        mobile: this.codeForm.mobile,
      };
      getCode(params).then((res) => {
        if (res.code === 200) {
          this.$message({ message: "发送成功", type: "success" });
        } else {
          this.$message.error("新增失败,请重试!");
        }
      });
    },
    // 显示隐藏密码
    showPassword() {
      this.isOpen = this.isOpen === "password" ? "text" : "password";
    },
    // 联系管理员
    // concatFunc() {
    //   this.$confirm("023-62652911,023-62652917", "联系管理员", {
    //     customClass: "uni-message-box",
    //     confirmButtonText: "返回登陆",
    //     showCancelButton: false,
    //     center: true,
    //   });
    // },
    // 登陆
    async refer(code) {
      let params;
      if (code === "验证码") {
        params = this.codeForm
        v1MobileLogin(params).then((res) => {
          if (res.code === 200) {
            setStore("token", res.result.token); //token
            setLocalStore("token", res.result.token); //token
            setStore("userInfo", res.result); //用户信息
            this.$store.dispatch('permission/userInfoActions', JSON.stringify(res.result));
            // this.$message.success("登陆成功");
            if (res.result.user_type === "teacher") {
              this.$store.commit("common/changeTeacherMutation", '2');
              // 根据老师的类型跳转页面
              this.$router.replace({
                path: this.IdentityFilter(
                  // res.result.teacher_type_array[0]
                  '2'
                ),
              });
            } else if (res.result.user_type === "student") {
              this.classList = res.result.classList
              if(this.classList.length > 1){
                this.isShowPort = 3;
                return
              }
              this.classCurrent = this.classList[0].class_id
              this.classConfirm(res);
              // this.selectZy(res.result.classList[0].profession_id);
              // this.selectZy(res.result.classList[0].class_id);
              // if (res.result.first_login_verify === 0) {
              //   // this.$router.push("/upDataIDQr");
              //   this.$router.push("/verify");
              //   return;
              // }
              // this.$router.replace({
              //   path: "/Template",
              // });
            }
          }
        });
      } else if(code === '密码') {
        params = {
          account: this.ruleForm.account,
          password: this.ruleForm.password,
        };
        login(params).then((res) => {
          if (res.code === 200) {
            setStore("token", res.result.token); //token
            // setLocalStore("token", res.result.token); //token
            setStore("userInfo", res.result); //用户信息
            this.$store.dispatch('permission/userInfoActions', JSON.stringify(res.result));

            // this.$message.success("登陆成功");
            if (res.result.user_type === "teacher") {
              // console.log(res.result.teacher_type_array);
              this.$store.commit("common/changeTeacherMutation", '2');
              this.$router.replace({
                // path: this.IdentityFilter(res.result.teacher_type_array[0]),
                path: this.IdentityFilter('2'),
              });
            } else if (res.result.user_type === "student") {
              if(this.portValue === 'adult'){
                this.$store.dispatch('permission/enterConfirmActions', res.result.class_info.enter_confirm);
                this.$store.dispatch('permission/enterSchoolImgCheckActions', res.result.enter_school_img_check);
                if(res.result.enter_school_img){
                  this.$store.dispatch('permission/enterSchoolImgActions', res.result.enter_school_img);
                }
                if(res.result.sign_img){
                  this.$store.dispatch('permission/signImgActions', res.result.sign_img);
                }
              }
              this.$store.dispatch('permission/firstLoginVerifyActions', res.result.first_login_verify);
              this.classList = res.result.classList
              if(this.classList.length > 1){
                this.isShowPort = 3;
                return
              }
              this.classCurrent = this.classList[0].class_id;
              this.classConfirm(res);
              // // this.selectZy(res.result.classList[0].profession_id);
              // if (res.result.first_login_verify === 0) {
              //   // this.$router.push("/upDataIDQr");
              //   this.$router.push("/verify");
              //   return;
              // }
              // // if (res.result.is_notification == 0) {
              // //   this.$router.push("/notice");
              // //   return;
              // // }
              // this.$router.replace({
              //   path: "/Template",
              // });
            }
          }
        });
      }else if(code === 'practicalAssessment'){
        // 实践考核入口
        params = this.practicalAssessmentRuleForm;
        pracLogin(params).then(res => {
          if(res.code == 200){
            setStore("token", res.result.token); //token
            // setLocalStore("token", res.result.token); //token
            setStore("userInfo", res.result); //用户信息
            this.$store.dispatch('permission/userInfoActions', JSON.stringify(res.result));

            this.$router.push({
              name: "practicalAssessment",
            });
          }
        });
      }
    },

    async classConfirm(loginRes){
      if(this.$base.isNull(this.classCurrent)){
        this.$message.warning("请选择班级");
        return
      }
      let id = this.classCurrent

      let res = await selectMajor({class_id: id});
      if(res.code != 200){
        this.$message.error(res.msg);
        return
      }

      let arr = this.classList.filter(item => item.class_id == id)
      let data = arr[0]
      this.gerStudentMajorMutation(data);
      // 确认信息
      if(this.portValue === 'adult'){
        let classInfo = loginRes.result.class_info;
        if(classInfo.enter_confirm == 0){
          this.$router.push({
            path: "/confirmInfo",
          });
          return;
        }
      }
      if(data.first_login_verify == 0){
        this.$router.push({
          path: "/verify",
          query: {
            classId: id,
          },
        });
        return;
      }
      if(this.portValue === 'adult'){
        if(loginRes.result.enter_school_img_check != 2){
          this.$router.push({
            path: "/uploadAdmissionPhotos",
          });
          return;
        }
      }
      // this.$router.replace({
      //   name: "home",
      // });
      this.$router.push({
        name: "home",
      });
    },

    async selectZy(val) {
      await selectMajor({
        class_id: val,
      });
    },
    //  老师身份过滤
    IdentityFilter(value) {
      // console.log(value);
      if (value == "3") {
        //  阅卷老师
        return "/markingData";
      } else if (value == "1") {
        //  班主任
        return "/headTeacher";
      } else if (value == "2") {
        // 上课老师
        return "/attendClassTeacher";
      } else {
        //  暂时还没有阅卷督察
        return "/headTeacher";
      }
    },
  },
};
</script>
<style lang="scss">
// elementUi样式覆盖

.uni-login {
  // 选择入口
  .login-content.choice-port{
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    .port-box{
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      &.port-box1{
        margin-top: 60px;
      }
      &.port-box2{
        margin-bottom: 20px;
      }

      .port-item{
        width: 50%;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        &:not(:last-child)::after{
          content: '';
          width: 1px;
          height: 162px;
          background-color: #DEDEDE;
          position: absolute;
          right: 0;
          top: 50%;
          margin-top: -81px;
        }
        .item-title{
          height: 40px;
          font-size: 15px;
          font-weight: bold;
          color: #333333;
          padding: 0 10px;
          text-align: center;
          display: flex;
          align-items: center;
        }
        .item-img{
          width: 60px;
          height: 60px;
          margin-top: 10px;
          .img{
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
        .item-btn{
          margin-top: 20px;
          .btn{
            // width: 152px;
            // height: 36px;
            width: 130px;
            height: 36px;
            // line-height: 36px;
            border-radius: 18px;
          }
        }
      }
    }
  }
  .el-input__inner {
    border: none;
    border-bottom: 1px solid $gray;
    border-radius: 0;
    padding-left: 0;
    padding-right: 0;
  }

  .uni-tabs {
    padding: 0 70px;

    .el-tabs__nav-scroll {
      display: flex;
      justify-content: center;
    }

    .el-tabs__nav-wrap::after {
      background: none;
    }

    .el-tabs__item {
      font-size: 18px;
    }
  }
}

.uni-message-box {
  width: 350px !important;
  border-radius: 20px;
  background: url("~@/assets/images/concat_bg.png") #fff center bottom no-repeat;
  background-size: 100% auto;

  .el-message-box__title {
    font-size: 16px;
    color: $grayDark;
  }

  .el-message-box__content {
    font-size: 30px;
    font-weight: bold;
  }

  .el-button {
    width: 140px;
    height: 48px;
    font-size: 16px;
    margin-top: 20px;
    border-radius: 8px;
  }
}
</style>
<style lang="scss" scoped>
.uni-login {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  background: url("~@/assets/images/login_bg.png") #eaeef7 center no-repeat;

  .logo-title {
    height: 95px;
    margin-top: 80px;
    margin-left: 100px;
  }

  .ori-footerUrl {
    width: 100%;
    position: absolute;
    bottom: 10px;
    color: #7f7f7f;
    display: flex;
    align-items: center;
    justify-content: center;
    i {
      width: 20px;
      height: 20px;
      background: url("~@/assets/images/securityIcon.jpg") no-repeat;
      background-size: 100% 100%;
      display: inline-block;
      margin-right: 5px;
    }

    span {
      cursor: pointer;

      &:hover {
        color: #2e58ff;
      }
    }
  }

  .login-container {
    width: 1000px;
    height: 550px;
    background: $white;
    background: url("~@/assets/images/login_bg4.png") -15px -15px no-repeat;
    position: relative;
    box-shadow: 4px 4px 10px #e2e6ee;
  }

  .login-content {
    width: 50%;
    height: 100%;
    background: $white;
    float: right;
    position: relative;
    &_title{
      text-align: center;
      font-size: 18px;
      position: absolute;
      width: 100%;
      top: 24px;
    }
    &_icon{
      position: absolute;
      left: 20px;
      top: 20px;
      font-size: 24px;
      cursor: pointer;
      z-index: 9;
    }
    &_select{
      display: flex;
      flex-direction: column;
      height: 100%;
      align-items: center;
      justify-content: center;
      width: 80%;
      margin: 0 auto;
    }
    .wx {
      height: 45px;
      line-height: 45px;
      text-align: right;
      color: $primary;
      margin: 8px 8px 50px 8px;

      .img {
        margin-right: 6px;
      }

      .uni-login-type {
        float: right;
        width: 45px;
        height: 45px;
        cursor: pointer;
        background: url("~@/assets/images/ew_icon.png") no-repeat;
        background-size: 100% 100%;

        &.active {
          background: url("~@/assets/images/computer_icon.png") center no-repeat;
          background-size: 100% 100%;
        }
      }
    }
  }

  .refer-btn {
    width: 100%;
    height: 56px;
    border-radius: 28px;
    margin-top: 25px;
    font-size: 16px;
  }

  .uni-input-group {
    position: relative;
    margin-top: 30px;

    .uni-label {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      color: #999;
      transition: all 0.4s cubic-bezier(0.23, 1, 0.32, 1);
      font-size: 16px;
      transform-origin: left top;
      z-index: $zindexTooltip;

      &.active {
        transform: translateY(-120%) scale(0.8);
      }
    }

    .iconfont {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      cursor: pointer;
      font-size: 22px;
    }
  }

  .uni-tips {
    margin-top: 25px;
    text-align: center;
    font-size: 13px;

    .link {
      cursor: pointer;
      color: $primary;
    }
  }

  .unit-bootom-img {
    width: 396px;
    position: absolute;
    bottom: -90px;
    left: -50px;
  }

  .uni-code {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 104px;
    height: 36px;
    font-size: 12px;
    z-index: $zindexTooltip;
    padding: 0;
  }

  .uni-wx-content {
    text-align: center;

    .tit {
      font-size: 18px;
    }

    .ew-box {
      width: 200px;
      height: 200px;
      //border: 1px solid $gray;
      //overflow: hidden;
      //margin: 40px auto 0;
    }

    .tips {
      margin-top: 10px;
    }
  }
}
.uni-login .logo-title{
  margin-left: 50px;
}
</style>
